// import React, { useContext, useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { getAudioAndVideoFiles } from '../../redux/features/audioAndVideoFiles/audioAndVideoSlice';
// import AppContext from '../../storage/AppContext';
// import Header from '../header/Header'
// import ReactPlayer from 'react-player'
// import NewHeader from '../header/NewHeader';
// import "./index.css"
// import { useNavigate } from 'react-router-dom';

// const ViewMediaFiles = () => {
    
//     const [type, setType] = useState('audio')
//     const [currentMedia, setCurrentMedia] = useState('')

//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const appContext = useContext(AppContext);
//     const userDetails = appContext?.userDetails

//     const getMediaFilesDetails = useSelector(state => state.audioAndVideo.getMediaFilesDetails)
//     const filteredMediaDetails = getMediaFilesDetails?.data?.filter((each) => each.type.includes(type))

//     useEffect(() => {
//         const branch = userDetails?.data?.branch
//         dispatch(getAudioAndVideoFiles({branch}))
//     }, [])
    
//     const onClickAudioFiles = () => {
//         setType('audio')
//     }

//     const onClickVideoFiles = () => {
//         setType('video')
//     }

//     const onClickPlay = (media) => {
//         setCurrentMedia(media.name)
//     }

//     const onChangeMedia = (e) => {
//         const name = e.target.files[0].name;
//         const data = e.target.files[0]
//         const contentType = e.target.files[0].type
//         const url =  URL.createObjectURL(e.target.files[0])

//         const mediaDetails = {url,type:contentType,name,mediaData:data}
//         navigate("/saveMedia",{state:mediaDetails})
//     }

//     console.log("filteredMediaDetails",filteredMediaDetails)
//   return (
//     <>
//         {/* {userDetails?.active && <Header />} */}
//         {userDetails?.active && <NewHeader />} 

//         <div className='px-4 mt-2'>
//             <div className='p-3 media-heading'>
//                 <p className="ml-3" style={{fontSize:'24px'}} >Media</p>
//             </div>  
//             <div className='media-container'>
//                 <div className='p-3 d-flex justify-content-between'>
//                     <div>
//                         <button className={`audio-video-button audio ${type === 'audio' && 'media-active-button'}`} onClick={onClickAudioFiles}>Audio Files</button>
//                         <button className={`audio-video-button video ${type === 'video' && 'media-active-button'}`} onClick={onClickVideoFiles}>Video Files</button>
//                     </div>
//                     {userDetails?.active && <div>
//                         <input
//                             className="inputfile"
//                             type="file"
//                             id="file"
//                             onChange={onChangeMedia}
//                             accept="video/*,audio/*"
//                         />
//                         <label htmlFor="file">Upload Audio/Video</label>
//                     </div>}
//                     {/* <button className='add-media-button' onClick={() => {navigate('/saveMedia')}}>Upload Audio/ Video</button> */}
//                 </div>
//                 <hr className='m-0'/>
//                 {filteredMediaDetails.map((each,i) =>{ 
//                     return <div key={i} className="mt-2 mb-2 p-3">
//                         <h5>Name of the file : {each.name}</h5>
//                         {type.includes('audio') ? <ReactPlayer playing={currentMedia === each.name} onPlay={() => {onClickPlay(each)}} height='60px' url={each.url} controls={true} /> : <ReactPlayer playing={currentMedia === each.name} onPlay={() => {onClickPlay(each)}}  url={each.url} controls={true} />}
//                     </div>  
//                 })}
//             </div>
//         </div>
//     </>
//   )
// }

// export default ViewMediaFiles




import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAudioAndVideoFiles } from '../../redux/features/audioAndVideoFiles/audioAndVideoSlice';
import AppContext from '../../storage/AppContext';
import Header from '../header/Header'
import ReactPlayer from 'react-player'
// import NewHeader from '../header/NewHeader';
import "./index.css"
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

const ViewMediaFiles = () => {

    const [type, setType] = useState('audio')
    const [currentMedia, setCurrentMedia] = useState('')

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const appContext = useContext(AppContext);
    const userDetails = appContext?.userDetails

    const getMediaFilesDetails = useSelector(state => state.audioAndVideo.getMediaFilesDetails)
    const filteredMediaDetails = getMediaFilesDetails?.data?.filter((each) => each.type.includes(type))


    let searchParams = new URLSearchParams(window.location.search);

    const redirectPage = searchParams.get('redirect')
    const studentBranch = searchParams.get('branch')

    useEffect(() => {
        let branch;
        if(redirectPage==='native' && studentBranch){
            branch = studentBranch
        }else{
            branch = userDetails?.data?.branch
        }
        dispatch(getAudioAndVideoFiles({ branch }))
    }, [])

    const onClickAudioFiles = () => {
        setType('audio')
    }

    const onClickVideoFiles = () => {
        setType('video')
    }

    const onClickPlay = (media) => {
        setCurrentMedia(media.name)
    }

    const onChangeMedia = (e) => {
        const name = e.target.files[0].name;
        const data = e.target.files[0]
        const contentType = e.target.files[0].type
        const url = URL.createObjectURL(e.target.files[0])

        const mediaDetails = { url, type: contentType, name, mediaData: data }
        navigate("/saveMedia", { state: mediaDetails })
    }

    console.log("filteredMediaDetails", filteredMediaDetails)
    return (
        <>
            {userDetails?.active && <Header />}
            {/* {userDetails?.active && <NewHeader />} */}
            {getMediaFilesDetails.status === 'loading' ? (<div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'><Spinner animation="border" role="status"></Spinner></div>):
            <div className='px-4 mt-2'>
                <div className='p-3 media-heading'>
                    <p className="media-Text" style={{ fontSize: '24px' }} >Media</p>
                </div>
                <div className='media-container'>
                    <div className='media-buttons p-1'>
                        <div className='file-buttons p-1'>
                            <button className={`audio-video-button audio ${type === 'audio' && 'media-active-button'}`} onClick={onClickAudioFiles}>Audio Files</button>
                            <button className={`audio-video-button video ${type === 'video' && 'media-active-button'}`} onClick={onClickVideoFiles}>Video Files</button>
                        </div>
                        {/* {userDetails?.active && <div className='p-1'>
                            <input
                                className="inputfile"
                                type="file"
                                id="file"
                                onChange={onChangeMedia}
                                accept="video/*,audio/*"
                            />
                            <label htmlFor="file">Upload Audio/Video</label>
                        </div>} */}
                        {/* <button className='add-media-button' onClick={() => {navigate('/saveMedia')}}>Upload Audio/ Video</button> */}
                    </div>
                    {/* <hr className='m-0 hrline' /> */}
                    {filteredMediaDetails.length > 0 ? filteredMediaDetails.map((each, i) => {
                        return <div key={i} className="mt-2 mb-2 p-3 media-card">
                            <h5 className='media-name-heading mx-2 mb-3 '>{each.name}</h5>
                            {type.includes('audio') ? <ReactPlayer className="col-12 col-md-6" style={{ maxHeight: 45 }} playing={currentMedia === each.name} onPlay={() => { onClickPlay(each) }} url={each.url} controls={true} /> : <ReactPlayer className="col-12 col-md-6" playing={currentMedia === each.name} onPlay={() => { onClickPlay(each) }} url={each.url} controls={true} />}
                        </div>
                    }) :
                    <div className='d-flex justify-content-center align-items-center mt-5 mb-5'><h5>No Files Found</h5></div>}
                </div>
            </div>}
        </>
    )
}

export default ViewMediaFiles